import React from "react";

const Template = () => {
  return (
    <div className="h-full dark:bg-[#292930] pb-20 pt-36">
      <div className="flex items-center">
        <h1 className="text-5xl w-1/3 dark:text-[#d3d3d4] ml-32 left-12 font-bold font-dmsans">
          Why buy the template from us?
        </h1>
        <p className="text-xl mx-96 w-1/4 mr-16 dark:text-[#d3d3d4] text-gray-500">
          Every template is built with such efforts that they are ready to meet
          all of our clients’ expectations.
        </p>
      </div>
      <div className="mt-16 z-1 flex justify-center gap-8">
        <div className="bg-white flex flex-col h-60 rounded-xl w-400 dark:bg-[#212121]">
          <div className="flex mt-10 ml-10 items-center">
            <div className="rounded-full h-16 flex items-center justify-center w-16 bg-[#FFDC60] ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-22.png"
                className=""
                alt=""
              />
            </div>
            <div>
              <h2 className="ml-5 dark:text-[#d3d3d4] font-bold text-xl w-48 font-dmsans">
                A Complete Product for Your Business
              </h2>
            </div>
          </div>
          <div className="ml-10 mr-4 mt-3 dark:text-[#d3d3d4]">
            <p>
              We build a template that is rich in content and has a good user
              interface to deliver a premium user experience for your customers.
            </p>
          </div>
        </div>
        <div className="bg-white flex flex-col h-60 rounded-xl w-400 dark:bg-[#212121]">
          <div className="flex mt-10 ml-10 items-center">
            <div className="rounded-full h-16 flex items-center justify-center w-16 bg-[#FFDC60] ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-22.png"
                className=""
                alt=""
              />
            </div>
            <div>
              <h2 className="ml-5 dark:text-[#d3d3d4] font-bold text-xl w-48 font-dmsans">
                A Complete Product for Your Business
              </h2>
            </div>
          </div>
          <div className="ml-10 mr-4 mt-3 dark:text-[#d3d3d4]">
            <p>
              We build a template that is rich in content and has a good user
              interface to deliver a premium user experience for your customers.
            </p>
          </div>
        </div>
        <div className="bg-white flex flex-col h-60 rounded-xl w-400 dark:bg-[#212121]">
          <div className="flex mt-10 ml-10 items-center">
            <div className="rounded-full h-16 flex items-center justify-center w-16 bg-[#FFDC60] ">
              <img
                src="https://new.axilthemes.com/demo/react/abstrak/images/icon/icon-22.png"
                className=""
                alt=""
              />
            </div>
            <div>
              <h2 className="ml-5 dark:text-[#d3d3d4] font-bold text-xl w-48 font-dmsans">
                A Complete Product for Your Business
              </h2>
            </div>
          </div>
          <div className="ml-10 mr-4 mt-3 dark:text-[#d3d3d4]">
            <p>
              We build a template that is rich in content and has a good user
              interface to deliver a premium user experience for your customers.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-10 flex justify-center gap-6">
        <a href="/" className="overflow-hidden rounded-xl hover:shadow-2xl">
          <div className="bg-white group dark:bg-[#212121] flex flex-col h-64 rounded-xl w-400 relative overflow-hidden ">
            <div className="ml-10 mt-8 flex items-center">
              <h1 className="dark:text-[#d3d3d4] text-3xl font-dmsans font-bold w-1/3">
                Online Documentation
              </h1>
            </div>
            <div className="ml-10 mt-4">
              <p className="dark:text-[#d3d3d4] text-gray-500">
                Well organized and up to date
              </p>
            </div>
            <div className="ml-10 mt-10">
              <div className="w-[68px] h-[46px] group-hover:bg-purple-500 group-hover:shadow-lg transition duration-100 flex items-center justify-center rounded-3xl bg-[#5956E9]">
                <svg
                  className="text-white flex "
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 256 512"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                </svg>
              </div>
            </div>
          </div>
        </a>

        <a href="/" className="overflow-hidden rounded-xl hover:shadow-2xl">
          <div className="bg-white group dark:bg-[#212121]  flex flex-col h-64 rounded-xl w-400 relative overflow-hidden ">
            <div className="ml-10 mt-8 flex items-center">
              <h1 className="text-3xl dark:text-[#d3d3d4] font-dmsans font-bold w-4/6">
                Submit a Support Ticket
              </h1>
            </div>
            <div className="ml-10 mt-4">
              <p className="text-gray-500 dark:text-[#d3d3d4]">
                We response within 1 Business day. weekends excluded.
              </p>
            </div>
            <div className="ml-10 mt-4">
              <div className="w-[68px] h-[46px] group-hover:bg-purple-500 group-hover:shadow-lg transition duration-100 flex items-center justify-center rounded-3xl bg-[#5956E9]">
                <svg
                  className="text-white flex "
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 256 512"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path>
                </svg>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Template;
